var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"neko-dice-panel"},_vm._l((_vm.diceList),function(dice){return _c('dice-animator',{key:dice.key,attrs:{"dice":dice}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }